<template>
  <div class="calendar-wrapper">
    <FullCalendar ref="fullCalendar" :options="calendarOptions" />
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"

export default {
  name: "FullCalendarWrapper",
  components: { FullCalendar },
  props: {
    events: { type: Array, default: () => [] }
  },
  data () {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        headerToolbar: false, // This removes the arrows and "today" button
        events: [],
        selectable: true,
        eventDisplay: "list-item",
        dateClick: (info) => {
          this.$emit("dateSelected", info.dateStr)
        }
      }
    }
  },
  watch: {
    events: {
      immediate: true,
      handler (newEvents) {
        this.calendarOptions.events = newEvents
      }
    }
  },
  methods: {
    // API method to jump to a specific date
    gotoDate (dateStr) {
      const calendarApi = this.$refs.fullCalendar.getApi()
      calendarApi.gotoDate(dateStr)
    }
  }
}
</script>
<style scoped>
  /* Scoped styles to customize the appearance of the event dots and text */
  /* 1. Ensure the event background is transparent and text is dark */
  ::v-deep .fc-daygrid-event {
    background-color: transparent !important;
    border: none !important;
    color: #444 !important; /* Darker text for readability on white background */
    font-size: 11px;
    font-weight: 500;
    cursor: pointer;
  }

  /* 2. Style the dot */
  ::v-deep .fc-daygrid-event-dot {
    border-width: 4px !important; /* Adjust size of the dot */
    border-radius: 50%;
    margin-right: 4px;
  }

  /* 3. Remove the hover background effect if desired */
  ::v-deep .fc-daygrid-event:hover {
    background-color: #f8f9fa !important;
  }

  /* 4. Fix alignment of text next to the dot */
  ::v-deep .fc-event-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ::v-deep .fc-daygrid-dot-event .fc-event-title {
    display: inline-block;
    vertical-align: middle;
    color: #444; /* Ensure text color is consistent */
  }
</style>
